<template>
    <div class="d-flex justify-content-center align-items-center">
      <span @click="createdRelPDF()">
        <v-icon x-large  color="red">  mdi-file-pdf-box </v-icon>
      </span>
  
      <span @click="createdRelXLS()">
        <v-icon x-large  color="green"> mdi-file-excel-outline </v-icon>
      </span>
    </div>
  </template>
  <script>
  import moment from 'moment'
  import jsPDF from 'jspdf'
  import 'jspdf-autotable'
  import Events from '@/core/service/events'
  import { size, get, flatMap } from 'lodash'
  import { mapGetters } from 'vuex'
  import xls from 'exceljs'
  import FileSave from 'file-saver'
  import configPDF from '@/views/components/PDFXLS/configPDF'
  import { formatDate } from '@/core/service/utils'
  // import logo from '@/assets/img/ic_logo_marca.png'
  import { logo } from './logoBase64'
  import {alertSnackbar} from '@/core/service/utils'
  
  export default {
    name: 'relatorioTestePdf',
    props:['params'],
    computed: {
      ...mapGetters('auth', ['user'])
    },
    data () {
      return {
        alphabetData: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      }
    },
    methods: {
      formatResponseKey(res) {
        if (res.data.resultMap && res.data.resultMap.results ) return res.data.resultMap.results
        if (res.data.resultMap && res.data.resultMap.resultGroup) return flatMap(res.data.resultMap.resultGroup, it => it.dados)
        if (res.data.result && res.data.result[0].payments) return flatMap(res.data.result, it => it.payments)
        if (res.data.resultMap && !res.data.resultMap.results) return res.data.resultMap
        return res.data.data
      },
      
      getDateSystems(res) {
        const date = res.data && res.data.date
        return date ? date : moment().format('DD/MM/YYYY HH:mm:ss')
      },

      createdPageNumberInFooter (docPdf) {
         // marcador de pagina 
        let pageCount = docPdf.internal.getNumberOfPages(); //Total Page Number
        console.log('teste', pageCount)
        for(let i = 0; i < pageCount; i++) { 
          docPdf.setPage(i); 
          let pageCurrent = docPdf.internal.getCurrentPageInfo().pageNumber; //Current Page
          docPdf.setFontSize(6);
          const texto = 'Pag: ' + pageCurrent + ' de ' + pageCount
          const sysEndX = (docPdf.internal.pageSize.getWidth() -  docPdf.getTextWidth(texto))
          docPdf.text(texto, sysEndX -2, docPdf.internal.pageSize.getHeight() - 2);
        }
      },

      async createdRelPDF () {
        const vm = this
        Events.$emit('relPage::loading', true)
        const { params } = this
      
        if(params.validate && params.validate.$invalid){
          this.params.validate.$touch()
          return false
        }
        
        let nameFile = `${params.fileName}`
        
        // realiza request
        params.vm[params.action](params.obj).then(res => {
          Events.$emit('relPage::loading', true)
          nameFile += moment(res.data.date, 'DD/MM/YYYY HH:mm:ss').format('[-]DD-MM-YYYY-HHmmss')


          if (size(res.data.resultMap) === 0 && size(res.data.data) === 0 && size(res.data.result) === 0) {
            alertSnackbar('Valor selecionado sem dados.', 'warning')
            return
          }
          
          const dados = vm.formatResponseKey(res)
          const dateSystem = vm.getDateSystems(res)

          // caso seja grupo de tabelas
          if (dados[0] && size(dados[0].results) !== 0) {
            vm.multiplePDF(dados, nameFile, dateSystem)
            return 
          }

          // criando headers Ex: { dataKey: 'id', header: 'ID' },
          const headers = params.headers
          const obj = []
          console.log(dados)
          dados.forEach((it) => {
            const values = headers.map((v) => {
              let key = get(it, v.dataKey)
              if ((key || key === null) && v.type === 'currency') key = vm.numberFormat(key)
              if ((key || key === null) && v.type === 'date') key = vm.dateFormat(key, v.dateFormat)
              if ((key || key === null) && v.type === 'status') key = vm.statusFormat(key)
              if ((key || key === null) && v.type === 'movimentacaoType') key = vm.movimentacaoTypeFormat(key)
              if ((key || key === null) && v.type === 'dateDelete') key = vm.dateDelete(key)
              if ((key || key === null) && v.type === 'statusCredits') key = vm.statusCredits(key)
              if (key && v.type === 'text') key = String(key)
  
              return key
            })
            console.log('values', values)
            obj.push(values)
          })
          const docPdf = new jsPDF({ putOnlyUsedFonts: false, orientation: "landscape" })
          docPdf.autoTable(headers, obj, {
            tableWidth: vm.params.obj.width || 278,
            ...configPDF.defaultConfig,
            foot: [[params?.textoTotal, params?.valueTotal]],
            showFoot: params.showFooter ? "lastPage": "",
            footStyles: {
              fillColor: [217, 217, 214],
              textColor: [0, 0, 0],
              fontSize: 11
            },
            didDrawPage: (data) => {
              vm.createdHeadFooterPDF(docPdf, res.data.date, data, logo)
            }
          })

          this.createdPageNumberInFooter(docPdf)
          docPdf.save(nameFile)
  
        }).catch(e => {
          console.log(e.message)
          alertSnackbar(e.message || e.error, 'error')
          Events.$emit('relPage::loading', false)
        }).finally(() => Events.$emit('relPage::loading', false))
      },

      async multiplePDF (dados, filename = '', date) {
        const { params } = this
        const vm  = this
        
        let addHeaderPage = 1
        const docPdf = new jsPDF({ putOnlyUsedFonts: false, orientation: "landscape" })
        for (let table of dados) {
          if (!size(table.results)) return 
          /* body de cada tabela */
          const body = table.results.map(values => {
            const itens = params.headers.map(head => {
              let key = get(values, head.dataKey)
              if ((key || key === null) && head.type === 'currency') key = vm.numberFormat(key)
              if ((key || key === null) && head.type === 'date') key = vm.dateFormat(key, head.dateFormat)
              if (key && head.type === 'text') key = String(key)

              return key
            })
            return itens
          })
          docPdf.autoTable(params.headers, body, {
            tableWidth: params.obj.width || 278,
            ...configPDF.defaultConfig,
            pageBreak: 'auto',
            startY: docPdf.lastAutoTable ? docPdf.lastAutoTable.finalY + 15 : null,
            avoidPageSplit: true,
            foot: [[params?.textoTotal, params?.valueTotal]],
            showFoot: params.showFooter ? "lastPage": "",
            didDrawPage: (data) => {
              console.log(data)
              console.log(filename)
              vm.createdHeadFooterPDF(docPdf, date, data, logo)
              docPdf.setFontSize(10)
              const { pageNumber } = data.doc.getCurrentPageInfo()
              if (pageNumber === addHeaderPage) docPdf.text(`${table.entity_cod} - ${table.entity_name}`,  data.settings.margin.left, data.settings.startY -2)
              else {
                docPdf.text(`${table.entity_cod} - ${table.entity_name}`,  data.settings.margin.left, data.settings.margin.top - 2)
                addHeaderPage = pageNumber
              }
            },
          })
        }
        this.createdPageNumberInFooter(docPdf)
        docPdf.save(`${filename}`)
        
        return params
      },

      async createdHeadFooterPDF (docPdf, date, table, base64Img = null) {
        const vm = this
        
        docPdf.setTextColor(40)
        docPdf.setFontSize(8)

        if (base64Img) {
          docPdf.addImage(base64Img, 'PNG', table.settings.margin.left, 10, 18, 8)
        }

        if (vm.params.filters) {
          docPdf.text(vm.params.filters, table.settings.margin.left, table.settings.margin.bottom + 14)  
        } else if (vm.params.obj.dtInicial && vm.params.obj.dtFinal) {
          docPdf.setTextColor(100)
          let init = moment(vm.params.obj.dtInicial).format('DD/MM/YYYY')
          let final = moment(vm.params.obj.dtFinal).format('DD/MM/YYYY')
          docPdf.text(`Filtro: ${init} - ${final} `, table.settings.margin.left, table.settings.margin.bottom + 10)
        } else if (vm.params.obj.date) {
          docPdf.setTextColor(100)
          let ftDate = moment(vm.params.obj.date).format('DD/MM/YYYY')
          docPdf.text(`Filtro: ${ftDate}`, table.settings.margin.left, table.settings.margin.bottom + 10)
        }

        if (vm.params.obj.sweepstakeText || vm.params.obj.entityText || vm.params.obj.nrjogo) {
          const lotText = `Loteria: ${vm.params.obj.sweepstakeText}`
          const termText = `Terminal: ${vm.params.obj.entityText}`
          const codBilheteText = `Cod. Bilhete: ${vm.params.obj.nrjogo}`
          let text = vm.params.obj.sweepstakeText ? lotText + ', ' : ''
          text = vm.params.obj.entityText ? text + termText + ', ' : text
          text = vm.params.obj.nrjogo ? text + codBilheteText : text
          docPdf.text(text, table.settings.margin.left, table.settings.margin.bottom + 13)
        }

        if (vm.params.obj.groupByName) {
          let groupByName = vm.params.obj.groupByName
          let entInitial = vm.params.obj.entInitial
          let entFinal = vm.params.obj.entFinal
          docPdf.text(`${groupByName}: ${entInitial} - ${entFinal}`, table.settings.margin.left, table.settings.margin.bottom + 16)
        }

        docPdf.setTextColor(40)
        // data e hora da geracao
        docPdf.text(`Data de emissão: ${date}`, 10, 4) // top
        docPdf.text(`Data de emissão: ${date}`, 2, docPdf.internal.pageSize.getHeight() - 2)
        
        // titulo
        docPdf.setFontSize(20)
        docPdf.text(vm.params.title, (docPdf.internal.pageSize.getWidth() -  docPdf.getTextWidth(vm.params.title)) / 2 , 16)
        
        //usuario
        docPdf.setFontSize(8)
        let usuarioSys = `Usuário: ${vm.user.name}`
        const sysEndX = (docPdf.internal.pageSize.getWidth() -  docPdf.getTextWidth(usuarioSys))
        docPdf.text(usuarioSys, sysEndX - 10, table.settings.margin.bottom + 14)
        docPdf.text(usuarioSys, sysEndX - 20, docPdf.internal.pageSize.getHeight() - 2)
      },

      /* ---------------  XLSX  --------------- */
      async createdRelXLS () {
        Events.$emit('ValidacaoTerminal::validarTerminalSelected')
        
        const vm = this
        Events.$emit('relPage::loading', true)
        const { params } = this
        let workBook

        if(params.validate && params.validate.$invalid){
          this.params.validate.$touch()
          return false
        }
        
        // table.columns = headers
        params.vm[params.action](params.obj).then(res => {

          if (size(res.data.resultMap) === 0 && size(res.data.data) === 0 && size(res.data.result) === 0) {
            alertSnackbar('Valor selecionado sem dados.', 'warning')
            return
          }

          workBook = new xls.Workbook()
          workBook.creator = params.fileName
          workBook.created = moment()
          workBook.modified = moment()
          workBook.views = {
            x: 0, y:0,
            width: 1000,
            height: 2000,
            firstSheet: 0,
            activeTab: 0,
            visibility: 'visible'
          }
    
          const headers = params.headers.map(v => {
            return {
              style: { font: { name : 'helvetica', bold: true, underline: false, size: 12 }, },
              header: v.header,
              key: v.dataKey,
              width: 27,
              type: v.type,
              dateFormat: v.dateFormat || false,
            }
          })
          
          const table = workBook.addWorksheet(vm.params.fileName, {
            properties: { argb: '00B050'}
            // views:[{ state: 'frozen' }]
          })

          const imageId = workBook.addImage({
            base64: logo,
            extension: 'png',
          });

          // multiplos xls no mesmo arquivo
          const dados = vm.formatResponseKey(res)
          if (dados[0] && size(dados[0].results) !== 0) {
           vm.createMultipleRelXLS(dados, table, imageId)
            return true
          }

          let alphabet = vm.alphabetData.split('')
          alphabet = alphabet.slice(0, size(headers))
          
          const start = 3 // muito importante onde começa o headers

          table.addImage(imageId, 'A1:A2')
          table.mergeCells('A1:A2')

          /* Frescuras */
          table.getRows(0, start + 1)
          table.getCell('B1').value = `${params.title}`
          table.getCell('B1').font = { size: 18, bold: true }
          table.getCell('B1').alignment = { horizontal: 'center', vertical: 'center' }
          table.mergeCells(`B2:${alphabet[alphabet.length - 1]}1`)

          table.getRows(0, start + 1)
          table.getCell('B1').value = `${params.title}`
          table.getCell('B1').font = { size: 18, bold: true }
          table.getCell('B1').alignment = { horizontal: 'center', vertical: 'center' }
          /* HEADERS */
          headers.forEach((v, k) => {
            const key = `${alphabet[k]}${start}`
            table.getCell(`${key}`).value = v.header
            table.getCell(`${key}`).font = { size: 14, bold: true }
            table.getCell(`${key}`).alignment = { horizontal: 'center' }
          })

          /* Dados formatados */
          dados.forEach((it) => {
            const values = headers.map((v) => {
              let key =get( it, v.key)
              if ((key || key === null) && v.type === 'currency') key = vm.numberFormat(key || 0)
              if (key && v.type === 'text') key = String(key)
  
              if (key && v.type === 'date') {
                if (v.dateFormat) key = moment(key).format(v.dateFormat)
                else key = moment(key).format('DD/MM/YYYY HH:mm:ss')
              }
              
              if (key && v.type === 'dateDelete') {
                key = vm.dateDelete(key)
              }
              
              if (key && v.type === 'statusCredits') {
                key = vm.dateDelete(key)
              }
              return key
            })
            table.addRows([values], 'i')
          })
          
          /* Formatando dados das celulas */
          dados.forEach((v, k) => alphabet.forEach(v => {
              table.getCell(`${v}${k + start + 1}`).style = { size: 12, underline: false , bold: false }
            }))

            /** Filtro utilizado*/
            if (vm.params.filters) {
              table.insertRow(table.actualRowCount + 2, [ vm.params.filters ])
            } else if (vm.params.obj.dtInicial && vm.params.obj.dtFinal) {
              let init = moment(vm.params.obj.dtInicial).format('DD/MM/YYYY')
              let final = moment(vm.params.obj.dtFinal).format('DD/MM/YYYY')
              table.insertRow(table.actualRowCount + 2, [ `Filtro: ${init} - ${final} ` ])
            } else if (vm.params.obj.date) {
              let ftDate = moment(vm.params.obj.date).format('DD/MM/YYYY')
              table.insertRow(table.actualRowCount + 2, [ `Filtro: ${ftDate}` ])
            }

            if (vm.params.obj.sweepstakeText || vm.params.obj.entityText || vm.params.obj.nrjogo) {
              const lotText = `Loteria: ${vm.params.obj.sweepstakeText}`
              const termText = `Terminal: ${vm.params.obj.entityText}`
              const codBilheteText = `Cod. Bilhete: ${vm.params.obj.nrjogo}`
              let text = vm.params.obj.sweepstakeText ? lotText + ', ' : ''
              text = vm.params.obj.entityText ? text + termText + ', ' : text
              text = vm.params.obj.nrjogo ? text + codBilheteText : text
              table.insertRow(table.actualRowCount + 2, [ text ])
            }

            if (vm.params.obj.groupByName) {
              let groupByName = vm.params.obj.groupByName
              let entInitial = vm.params.obj.entInitial
              let entFinal = vm.params.obj.entFinal
              table.insertRow(table.actualRowCount + 2, [ `${groupByName}: ${entInitial} - ${entFinal}` ])
            }

            /* Nome do operador e data do relatorio*/
            table.insertRow(table.actualRowCount + 2, [ `Data de emissão: ${ moment(dados[0].date_system).format('DD/MM/YYYY HH:mm:ss') }` ])
            table.insertRow(table.actualRowCount + 2, [ `Usuário: ${ vm.user.name }` ])

        }).then(async () => vm.generatFileXLS(workBook)).catch(e => {
          console.log(e)
          console.log(e.message)
          alertSnackbar(e.message || e.error, 'error')
          Events.$emit('relPage::loading', false)

        }).finally(() => Events.$emit('relPage::loading', false))
      },
      createMultipleRelXLS (dados, table, imageId) {
        const { params } = this
        const vm = this
        let start = 1
        
        const alphabet = vm.alphabetData.split('').filter((v, k) => k <= params.headers.length -1)
        table.addImage(imageId, 'A1:A2')
        table.mergeCells('A1:A2')
        for (let it of dados) {        
          if (start === 1) {

            /* Titulo da tabela */
            // table.spliceRows(start, 2, [`${params.title}`]) 
            table.getCell('B1').value = `${params.title}`
            table.getCell(`B1`).font = { size: 18, bold: true }
            table.getCell(`B1`).alignment = { horizontal: 'center' }
            table.mergeCells(`B1:${alphabet[alphabet.length - 1]}2`)
            start++
            start++
          }
          
          /* Titulo de multiplas tables */
          table.insertRow(start + 1, [`${it.entity_cod}- ${it.entity_name}`])
          table.addRows([`${it.entity_cod}- ${it.entity_name}`]).commit
          table.mergeCells(`A${start + 1}:${alphabet[alphabet.length - 1]}${start + 1}`)
          table.getCell(`A${start + 1}`).font = { size: 12, bold: true }
          table.getCell(`A${start + 1}`).alignment = { horizontal: 'left' }
          start++

          for (let cell of it.results) {
            let values = []
            for (let v of params.headers) {
              let key = get(cell, v.dataKey)
              if ((key || key === null) && v.type === 'currency') key = vm.numberFormat(key || 0)
              if ((key || key === null) && v.type === 'status') key = vm.statusFormat(key || '')
              if ((key || key === null) && v.type === 'movimentacaoType') key = vm.movimentacaoTypeFormat(key || '')
              if (key && v.type === 'text') key = String(key)
              if (key && v.type === 'date') {
                if (v.dateFormat) key = moment(key).format(v.dateFormat)
                else key = moment().format('DD/MM/YYYY HH:mm:ss')
              }
              if (key && v.type === 'dateDelete') {
                key = vm.dateDelete(key)
              }
              values.push(key)
            }

            start++
            table.spliceRows(start, 1, values) 
          }
          ++start
        }

        /** Filtro utilizado*/
        if (vm.params.filters) {
          table.insertRow(table.actualRowCount + 2, [ vm.params.filters ])
        } else if (vm.params.obj.dtInicial && vm.params.obj.dtFinal) {
          let init = moment(vm.params.obj.dtInicial).format('DD/MM/YYYY')
          let final = moment(vm.params.obj.dtFinal).format('DD/MM/YYYY')
          table.insertRow(table.actualRowCount + 2, [ `Filtro: ${init} - ${final} ` ])
        } else if (vm.params.obj.date) {
          let ftDate = moment(vm.params.obj.date).format('DD/MM/YYYY')
          table.insertRow(table.actualRowCount + 2, [ `Filtro: ${ftDate}` ])
        }

        if (vm.params.obj.sweepstakeText || vm.params.obj.entityText || vm.params.obj.nrjogo) {
          const lotText = `Loteria: ${vm.params.obj.sweepstakeText}`
          const termText = `Terminal: ${vm.params.obj.entityText}`
          const codBilheteText = `Cod. Bilhete: ${vm.params.obj.nrjogo}`
          let text = vm.params.obj.sweepstakeText ? lotText + ', ' : ''
          text = vm.params.obj.entityText ? text + termText + ', ' : text
          text = vm.params.obj.nrjogo ? text + codBilheteText : text
          table.insertRow(table.actualRowCount + 2, [ text ])
        }

        if (vm.params.obj.groupByName) {
          let groupByName = vm.params.obj.groupByName
          let entInitial = vm.params.obj.entInitial
          let entFinal = vm.params.obj.entFinal
          table.insertRow(table.actualRowCount + 2, [ `${groupByName}: ${entInitial} - ${entFinal}` ])
        }

        /* Nome do operador e data do relatorio*/
        table.insertRow(start + 2, [ `Data de emissão: ${ moment(dados[0].results[0].date_system || '').format('DD/MM/YYYY HH:mm:ss') }` ])
        table.insertRow(start + 2, [ `Usuário: ${ vm.user.name }` ])
      },

      async generatFileXLS (workBook) {
        const { params } = this
        const buffer = await workBook.xlsx.writeBuffer()
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const type = '.xlsx'
        const blob = new Blob([buffer], { type: fileType })
        FileSave.saveAs(blob, `${params.fileName} Excel ${type}`)
        Events.$emit('relPage::loading', false)
      },
      numberFormat (v) {
        return Number(v || 0).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        })
      },

      dateFormat (v, dateFormat) {
        const dateFormated = formatDate(v, dateFormat || 'DD/MM/YYYY HH:mm:ss')
        return dateFormated !== 'Data inválida' ? dateFormated : '-'
      },

      statusFormat (v) {
        switch(v) {
          case 'B':
            return 'Baixado';
          default:
            return 'Pendente'
        }
      },

      movimentacaoTypeFormat (v) {
        switch(v) {
          case 'C':
            return 'Crédito';
          default:
            return 'Débito'
        }
      },

      dateDelete (v) {
        return v === '1970-01-01 00:00:00' ? '-' : formatDate(v)
      },

      statusCredits (v) {
        switch(v) {
          case 'C':
            return 'Cancelado';
          case 'A':
            return 'Ativado';
          default:
            return 'Não Ativado'
        }
      }
    }
  
  }
  </script>
  <style lang="scss" scoped>
    span {
      display: inline-block;      margin: 0 !important;
      cursor: pointer;
      i {
        font-size: 2rem !important;
      }
        position: relative;
        left: 10px;
      
    }
  </style>